module.exports = __webpack_public_path__ + "img/btn_red_hover.a1ff21a0.webp";